var map = {
	"./All mail.png": 4756,
	"./Archive.png": 7541,
	"./Bucket.png": 799,
	"./Delete.png": 5329,
	"./Drafts.png": 9684,
	"./Fire.png": 9600,
	"./Folder.png": 8226,
	"./Inbox.png": 3623,
	"./Label.png": 6680,
	"./Mailbox.png": 4709,
	"./Sent.png": 1997,
	"./Spam.png": 6658,
	"./Starred.png": 1066,
	"./Trash.png": 6592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8709;